import * as React from 'react';
import { SVGProps } from 'react';

const IconWideScreenFilledSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 5a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h8v2H8v2h8v-2h-3v-2h8a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H3Z"
    />
  </svg>
);
export default IconWideScreenFilledSizeM;
